import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { MatRadioChange } from '@angular/material/radio';
import { ServiceaftaleDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-dto';
import { ServiceaftaleStateEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/serviceaftale-state-enum';

@Component({
    selector: 'app-opsig-date',
    templateUrl: './opsig-date.component.html',
    styleUrls: ['./opsig-date.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OpsigDateComponent implements OnInit {
  serviceaftaleStateEnum: typeof ServiceaftaleStateEnum = ServiceaftaleStateEnum;

  @Input() form: UntypedFormGroup;
  @Input() periodEndDate: Date;
  @Input() serviceaftale: ServiceaftaleDto;

  opsigPr: typeof OpsigPr = OpsigPr;
  selectedOpsigType: OpsigPr = OpsigPr.Today;
  get hasEndDate(): boolean {
    return this.periodEndDate > new Date(null);
  }
  constructor() {}

  ngOnInit(): void {
    this.selectedOpsigType = this.form.get('opsigPr').value;
  }

  opsigPrChange($event: MatRadioChange) {
    const opsigPr = +$event.value;
    this.form.patchValue({ opsigPr: opsigPr });
    this.form.controls.opsigPr.updateValueAndValidity();

    switch (opsigPr) {
      case OpsigPr.Today:
        this.form.patchValue({ endDate: new Date() });
        break;
      case OpsigPr.EndOfInterval:
        this.form.patchValue({ endDate: new Date(this.periodEndDate) });
        break;
      case OpsigPr.Custom:
        this.form.patchValue({ endDate: null });
        break;
    }

    this.form.controls.endDate.updateValueAndValidity();
  }
}

export enum OpsigPr {
  Today,
  EndOfInterval,
  Custom,
}
